import * as Yup from 'yup';
import * as utils from './StrUtils.js';

const RSPhone = ({qObj}) => {
  let valObj = Yup.string();

  valObj = utils.setRequired(valObj, qObj);

  return valObj;
};

export default RSPhone;